import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { GO_TO_FLUSH } from '../../routes/paths';

const ResetToolBt: React.FC<{ className?: string; closeMe?: () => void }> = ({
    className,
    closeMe,
}) => {
    const history = useHistory();
    const onReset = () => {
        const isConfirmed = window.confirm(
            'Are you sure you want to reset your setup? Unsynced data will be lost.',
        );
        if (isConfirmed) {
            closeMe && closeMe();
            history.replace(GO_TO_FLUSH);
        }
    };

    return (
        <button onClick={onReset} className={className}>
            Reset
        </button>
    );
};

export default ResetToolBt;
